import { isProspectInvitePath } from "@fe/utils/is-prospect-invite-path";
import { scrubProspectInviteTokens } from "@fe/utils/scrub-prospect-invite-tokens";
import {
	type Breadcrumb,
	browserTracingIntegration,
	getReplay,
	init,
	replayCanvasIntegration,
	replayIntegration,
} from "@sentry/react";

export const initSentry = () => {
	const environment = import.meta.env.VITE_CF_ENV;

	// If no environment is passed, or this is a PR preview, don't initialise Sentry
	if (!environment || environment.startsWith("pr-")) return;

	init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment,
		integrations: [
			browserTracingIntegration(),
			replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
				unmask: [
					".error-message",
					".error-stack",
					".error-boundary",
					"pre",
					".react-error-overlay",
					'[role="alert"]',
					".ReactModal__Overlay",
					".sb-errordisplay",
					".sb-show-errordisplay",
				],
				beforeAddRecordingEvent: scrubProspectInviteTokens,
			}),
			replayCanvasIntegration({ enableManualSnapshot: true }),
			{
				name: "ScrubProspectInviteTokens",
				processEvent: scrubProspectInviteTokens,
				processSpan: scrubProspectInviteTokens,
			},
		],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		beforeBreadcrumb: stopReplayOnProspectInvite,
	});
	if (isProspectInvitePath(window.location.pathname))
		getReplay()?.stop({ flush: false });
};

function stopReplayOnProspectInvite(breadcrumb: Breadcrumb) {
	const to = breadcrumb.data?.to;
	if (
		breadcrumb.category === "navigation" &&
		typeof to === "string" &&
		isProspectInvitePath(new URL(to, window.location.origin).pathname)
	)
		getReplay()?.stop({ flush: false });
	return breadcrumb;
}
